export default __webpack_public_path__ + "static/media/reveal-article-pink.70f30eac.svg";